import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TaxiTimes, TaxiTimeComponent } from '../taxi-time/taxi-time.component';
import { ReportType } from '../../models/metric-cards.model';
import { MetricCardService } from '../../services/metric-card/metric-card.service';
import { NgClass } from '@angular/common';
import { DecodeHtmlStringPipe } from '../../pipes/decode-htm-string.pipe';
import { DecodeHtmlString } from '../../../../../core/src/app/feature-modules/deice/pipes/html-decode.pipe';

export class EmtTaxiOut {
  list: TaxiTimes[];
  constructor() {
    this.list = new Array<TaxiTimes>();
  }
}

@Component({
    selector: 'emt-taxi-time-collection',
    templateUrl: './taxi-time-collection.component.html',
    styleUrls: ['./taxi-time-collection.component.scss'],
    imports: [
        NgClass,
        TaxiTimeComponent,
        DecodeHtmlStringPipe,
        DecodeHtmlString,
    ],
})
export class EmtTaxiTimeCollectionComponent {
  @Input() data: EmtTaxiOut;
  @Input() title: string;
  @Input() showTimeRangeReport: boolean;
  @Input() showLabelTop: boolean;
  @Input() showButton: boolean;
  @Input() isCondensedMode: boolean;
  @Input() isStpd: boolean;
  @Output() taxiOutSelectionChange: EventEmitter<any> = new EventEmitter();

  constructor(private metricCardService: MetricCardService) {}

  getWidth() {
    return `${100 / this.data.list.length}%`;
  }

  public handleCardClick(reportType: ReportType): void {
    const taxiTimeBucketarr = this.data.list.filter(element => element.isChecked).map(element => element.taxiTimeId);
    this.taxiOutSelectionChange.emit(taxiTimeBucketarr);
    if (taxiTimeBucketarr.length > 0 && this.isStpd) {
      this.metricCardService.setSelectedReportType(reportType);
    } else if (this.isStpd === undefined) {
      this.metricCardService.setSelectedReportType(reportType);
    } else {
      console.log('error');
    }
  }

  taxiOutId(taxiOutData) {
    this.data.list.forEach(element => {
      if (element.taxiTimeId === taxiOutData.id) {
        element.isChecked = taxiOutData.status;
      }
    });
  }
}
